import { CollapsibleFineprintWidgetComponent } from './CollapsibleFineprintWidgetComponent';

export function CollapsibleFineprintWidgetComponentC(
  props: React.ComponentProps<typeof CollapsibleFineprintWidgetComponent>,
) {
  return <CollapsibleFineprintWidgetComponent {...props} />;
}
